import { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { cn } from '@/lib/cn';

type SortOption = 'latest' | 'trending' | 'top';

interface Props {
  activeSort: SortOption;
  onSortChange: (sort: SortOption) => void;
}

const OPTIONS: SortOption[] = ['latest', 'trending', 'top'];

export const SortToggle = memo(function SortToggle({ activeSort, onSortChange }: Props) {
  const { t } = useTranslation('news');
  return (
    <div className="flex gap-1 px-4 py-1.5">
      {OPTIONS.map((option) => {
        const isActive = activeSort === option;
        return (
          <button
            key={option}
            type="button"
            onClick={() => onSortChange(option)}
            className={cn(
              'rounded-[14px] px-3.5 py-1.5 text-[13px] font-semibold transition-opacity active:opacity-80',
              isActive ? 'bg-brand/15 text-brand' : 'text-fg-muted',
            )}
          >
            {t(`sort.${option}`, {
              defaultValue: option.charAt(0).toUpperCase() + option.slice(1),
            })}
          </button>
        );
      })}
    </div>
  );
});
